import { render, staticRenderFns } from "./image-with-text-cta.vue?vue&type=template&id=4ed1b190&"
import script from "./image-with-text-cta.vue?vue&type=script&lang=js&"
export * from "./image-with-text-cta.vue?vue&type=script&lang=js&"
import style0 from "./image-with-text-cta.vue?vue&type=style&index=0&id=4ed1b190&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports